export default "__VITE_ASSET__BPrIosrE__"